import { Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { FeedbackResponse } from 'v2/core/entities/feedback/content';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';

interface SurveyTypeQuestionProps {
  question: FeedbackResponse['question'];
}

const SurveyTypeQuestion = ({ question }: SurveyTypeQuestionProps) => {
  return (
    <Typography
      variant="subtitle1"
      sx={{
        wordBreak: 'break-word',
        fontWeight: 'bold',
      }}
    >
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <ContactSupportRoundedIcon />
        <Box>{question}</Box>
      </Stack>
    </Typography>
  );
};

export default SurveyTypeQuestion;
